<ng-template #cardContent>
  <div class="card omgui-card p-3 d-flex flex-column flex-sm-row justify-content-sm-start align-items-center h-100">
    <div *ngIf="icon" class="me-sm-3 mb-1 mb-sm-0">
      <ng-container *ngTemplateOutlet="icon.templateRef"></ng-container>
    </div>

    <h4 class="h5 m-0 text-center text-sm-start"> {{ label }} </h4>
  </div>
</ng-template>

<ng-container *ngIf="link">
  <ng-container *ngTemplateOutlet="linkView"></ng-container>
</ng-container>

<ng-container *ngIf="clickHandler">
  <ng-container *ngTemplateOutlet="clickableStaticView"></ng-container>
</ng-container>

<ng-container *ngIf="!link && !clickHandler">
  <ng-container *ngTemplateOutlet="staticView"></ng-container>
</ng-container>

<ng-template #linkView>
  <a
    [routerLink]="link"
    [omTrackLink]="trackLink"
    [queryParams]="queryParams"
    class="text-decoration-none omgui-card-link-wrapper"
    [ngStyle]="cardStyles"
  >
    <ng-container *ngTemplateOutlet="cardContent"></ng-container>
  </a>
</ng-template>

<ng-template #staticView>
  <div [ngStyle]="cardStyles">
    <ng-container *ngTemplateOutlet="cardContent"></ng-container>
  </div>
</ng-template>

<ng-template #clickableStaticView>
  <div
    class="interactive-card-wrapper"
    tabindex="0"
    (keyup)="clickHandler($event)"
    (click)="clickHandler($event)"
    [ngStyle]="cardStyles"
  >
    <ng-container *ngTemplateOutlet="cardContent"></ng-container>
  </div>
</ng-template>
